/* Adaptogeny.pl 2026-09-26: przełączanie formy (krople / kapsułki) na karcie produktu.
   1) galeria: pokazuje tylko media z altem [krople] / [kapsułki] zgodnym z wybranym wariantem,
   2) bloki metapól w sekcji main ([data-variant-block]) podmieniane z HTML pobranego przez product-info,
   3) sekcje z obrazem wariantu ([data-variant-aware]) przerenderowane przez Section Rendering API. */
(function () {
  function formaOf(variant) {
    if (!variant || !Array.isArray(variant.options)) return '';
    var idx = window.ADAPTOGENY_FORMA_INDEX;
    return idx >= 0 ? variant.options[idx] || '' : '';
  }
  /* Galeria: slajdy innej formy są WYJMOWANE z .swiper-wrapper do ukrytego schowka (ukryte slajdy o zerowej szerokości
     psuły Swiperowi indeksy w trybie loop na mobile: aktywny slajd lądował na ukrytym i galeria miała 0 px wysokości).
     Kolejność wraca po data-media-index; loop jest odbudowywany (loopDestroy/loopCreate), potem slideTo(0). */
  function rebuildList(g, wrapSel, itemSel, f) {
    var wrap = g.querySelector(wrapSel); if (!wrap) return;
    var host = wrap.parentElement;
    var holder = host.querySelector(':scope > .forma-holder');
    if (!holder) { holder = document.createElement('div'); holder.className = 'forma-holder'; holder.hidden = true; holder.style.display = 'none'; host.appendChild(holder); }
    var swEl = wrap.closest('.swiper'); var sw = swEl && swEl.swiper;
    if (sw && sw.params && sw.params.loop && typeof sw.loopDestroy === 'function') sw.loopDestroy();
    var items = Array.prototype.slice.call(wrap.querySelectorAll(itemSel)).concat(Array.prototype.slice.call(holder.querySelectorAll(itemSel)))
      .filter(function (el) { return !el.classList.contains('swiper-slide-duplicate'); });
    items.forEach(function (el) { if (el.dataset.formaOrder === undefined) el.dataset.formaOrder = el.dataset.mediaIndex || '0'; });
    items.sort(function (x, y) { return (+x.dataset.formaOrder) - (+y.dataset.formaOrder); });
    items.forEach(function (el) {
      var mf = el.dataset.forma; var hide = !!(mf && f && mf !== f);
      el.hidden = hide; el.toggleAttribute('data-forma-hidden', hide);
      el.classList.remove('swiper-slide-active', 'swiper-slide-next', 'swiper-slide-prev', 'swiper-slide-thumb-active');
      (hide ? holder : wrap).appendChild(el);
    });
    if (sw) {
      if (sw.params && sw.params.loop && typeof sw.loopCreate === 'function') sw.loopCreate();
      sw.update();
      if (sw.params && sw.params.loop) sw.slideToLoop(0, 0); else sw.slideTo(0, 0);
      if (typeof sw.updateAutoHeight === 'function') sw.updateAutoHeight(0);
    }
  }
  function applyGallery(f) {
    document.querySelectorAll('.product__media-gallery').forEach(function (g) {
      g.dataset.currentForma = f;
      rebuildList(g, '.product__media-list', '.product__media-item', f);
      rebuildList(g, '.thumbnail-list', '.product__thumbs-item', f);
    });
  }
  function currentForma() {
    var g = document.querySelector('.product__media-gallery'); return g ? (g.dataset.currentForma || '') : '';
  }
  /* start: po inicjalizacji Swipera (motyw ustawia aktywny slajd po pozycji medium, więc poprawiamy po nim) */
  (function boot(n) {
    var v = document.querySelector('.product__media-gallery-viewer');
    if (!(v && v.swiper) && n < 60) return setTimeout(function () { boot(n + 1); }, 100);
    var f = currentForma(); if (f) { applyGallery(f); setTimeout(function () { applyGallery(f); }, 700); }
  })(0);
  /* Plakietka „Made in the USA” tylko na pierwszym slajdzie karuzeli (na kolejnych zasłaniała tekst na kaflach) */
  (function badgeWatch() {
    var last = null;
    function bind() {
      var v = document.querySelector('.product__media-gallery-viewer'); var sw = v && v.swiper;
      var badge = document.querySelector('.product-badge-usa');
      if (!badge) return;
      if (sw && sw !== last) {
        last = sw;
        var upd = function () {
          var off = sw.realIndex !== 0;
          badge.classList.toggle('product-badge-usa--off', off);
          /* Adaptogeny.pl 2026-10-22: medale odznaczeń pod flagą znikają razem z nią */
          document.querySelectorAll('.product-badge-medal').forEach(function (m) { m.classList.toggle('product-badge-medal--off', off); });
        };
        sw.on('realIndexChange', upd); sw.on('slideChange', upd); upd();
      } else if (!sw) { badge.classList.remove('product-badge-usa--off'); document.querySelectorAll('.product-badge-medal').forEach(function (m) { m.classList.remove('product-badge-medal--off'); }); }
    }
    bind(); setInterval(bind, 500);
  })();
  /* Rozmiar opakowania: drugi wybór jest ukryty, ustawiamy go z wariantu o wybranej formie (w fazie capture, zanim motyw
     policzy wariant) i dopisujemy rozmiar do pigułek formy: „Krople · 30 ml”, „Kapsułki · 60 kapsułek” */
  function sizeIndex() {
    var pick = document.querySelector('[data-forma-size-picker]'); if (!pick) return -1;
    var inp = pick.querySelector('input[type=radio]'); if (!inp) return -1;
    var mm = /-(\d+)\s*$/.exec(inp.name || ''); return mm ? (+mm[1]) - 1 : -1;
  }
  function variantForForma(f) {
    var vs = window.ADAPTOGENY_VARIANTS || [], fi = window.ADAPTOGENY_FORMA_INDEX;
    for (var i = 0; i < vs.length; i++) if (vs[i].options && vs[i].options[fi] === f) return vs[i];
    return null;
  }
  function syncSize(f) {
    var si = sizeIndex(); if (si < 0) return;
    var v = variantForForma(f); if (!v) return;
    var size = v.options[si];
    document.querySelectorAll('[data-forma-size-picker] input[type=radio]').forEach(function (r) { r.checked = (r.value === size); });
  }
  document.addEventListener('change', function (e) {
    var t = e.target; if (!(t && t.type === 'radio')) return;
    var fs = t.closest('.product-form__input'); if (!fs || fs.hasAttribute('data-forma-size-picker')) return;
    var fi = window.ADAPTOGENY_FORMA_INDEX; var mm = /-(\d+)\s*$/.exec(t.name || '');
    if (!mm || (+mm[1]) - 1 !== fi) return;
    syncSize(t.value);
  }, true);
  function labelSizes() {
    var si = sizeIndex(); if (si < 0) return;
    document.querySelectorAll('.product-form__input:not([data-forma-size-picker]) input[type=radio]').forEach(function (r) {
      var mm = /-(\d+)\s*$/.exec(r.name || ''); if (!mm || (+mm[1]) - 1 !== window.ADAPTOGENY_FORMA_INDEX) return;
      var lab = document.querySelector('label[for="' + r.id + '"]'); if (!lab || lab.querySelector('.forma-size')) return;
      var v = variantForForma(r.value); if (!v) return;
      var sp = document.createElement('span'); sp.className = 'forma-size'; sp.textContent = '\u00b7 ' + v.options[si];
      var hid = lab.querySelector('.visually-hidden'); hid ? lab.insertBefore(sp, hid) : lab.appendChild(sp);
    });
  }
  labelSizes(); setInterval(labelSizes, 800);
  var busy = false;
  function refreshSections(variantId) {
    var hosts = Array.prototype.slice.call(document.querySelectorAll('[data-variant-aware]'));
    var ids = []; hosts.forEach(function (h) { var sec = h.closest('.shopify-section'); if (sec) { var id = sec.id.replace('shopify-section-', ''); if (ids.indexOf(id) < 0) ids.push(id); } });
    if (!ids.length || busy) return; busy = true;
    /* Section Rendering API: maksymalnie 5 sekcji na żądanie (8 dawało HTTP 400 i żadna sekcja się nie odświeżała - poprawka 30.09.2026) */
    var chunks = []; for (var i = 0; i < ids.length; i += 5) chunks.push(ids.slice(i, i + 5));
    Promise.all(chunks.map(function (part) {
      return fetch(window.location.pathname + '?variant=' + variantId + '&sections=' + part.join(','))
        .then(function (r) { return r.ok ? r.json() : {}; })
        .then(function (json) {
          part.forEach(function (id) {
            if (!json[id]) return;
            var tmp = document.createElement('div'); tmp.innerHTML = json[id];
            var inner = tmp.firstElementChild; var target = document.getElementById('shopify-section-' + id);
            if (inner && target) target.innerHTML = inner.innerHTML;
          });
        }).catch(function () {});
    })).finally(function () { busy = false; });
  }
  document.addEventListener('variant:changed', function (e) {
    var v = e.detail && e.detail.variant; if (!v) return;
    var f = formaOf(v); setTimeout(function () { applyGallery(f); }, 60); setTimeout(function () { applyGallery(f); }, 500); refreshSections(v.id);
  });
  function subscribe() {
    if (!(window.FoxTheme && FoxTheme.pubsub)) return setTimeout(subscribe, 200);
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function (ev) {
      var html = ev && ev.data && ev.data.html; if (!html) return;
      html.querySelectorAll('[data-variant-block]').forEach(function (src) {
        var key = src.dataset.variantBlock;
        document.querySelectorAll('[data-variant-block="' + key + '"]').forEach(function (dst) { dst.innerHTML = src.innerHTML; });
      });
    });
  }
  subscribe();
})();
